import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
export type Common_ContentProviderFragmentFragment = {
  __typename?: 'Content'
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: Types.ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
}

export const Common_ContentProviderFragmentFragmentDoc = gql`
  fragment Common_ContentProviderFragment on Content {
    contentProvider {
      provider
      providerKey
      ...Content_ProviderCommonFragment
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`
